import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import simpleFetch from "../../../../../../utils/simpleFetch";
import {
  ADMINISTRATOR,
  FINTECH,
  PLAN_ADMINISTRATOR,
} from "../../../../../utils/Roles";
import * as dataActions from "../../../../../utils/data/dataActions";
import { BILLING_PERIOD_LAST_VALID_INVOICE, GET_TEMPLATE_MISSING_FIELDS, INVOICE_REVIEW } from "../../../../../utils/data/models";
import userHasAccess from "../../../../../utils/userHasAccess";
import { EN } from "../../../../common/enums/languages";
import { getParsedErrors, renderErrorModal } from "../../../../common/form/FieldErrorHelper";
import InvoiceUtils from "./InvoiceUtils";
import {
  FAILURE,
  GENERATED,
  GENERATING,
  PUBLISHED,
  REVIEW,
  TEMPLATE,
} from "./enums/invoiceStatuses";
import { DRAFT } from "./enums/invoiceSteps";
import { ACTIVE, IMPLEMENTATION, INACTIVE } from "../../enums/clientStatusTypes";

class InvoiceState extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isInvoiceValid: true,
      errorsString: null,
      errorPath: "validation/clientFieldValidation/serverErrors",
      showModal: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.invoiceStatusCSS = this.invoiceStatusCSS.bind(this);
    this.checkInvoiceValidity = this.checkInvoiceValidity.bind(this);
    this.getReviewButton = this.getReviewButton.bind(this);
    this.getRefreshButton = this.getRefreshButton.bind(this);
    this.getStateDisplay = this.getStateDisplay.bind(this);
  }

  componentDidMount() {
    const { invoice } = this.props;
    if (
      invoice.invoiceStep == DRAFT.value &&
      [GENERATED.value, FAILURE.value].includes(invoice.invoiceStatusType) &&
      userHasAccess(PLAN_ADMINISTRATOR, false)
    )
      this.checkInvoiceValidity(invoice.invoiceId);
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  checkInvoiceValidity(invoiceId) {
    InvoiceUtils.checkInvoiceValidity(invoiceId, (result) => {
      this.setState({ isInvoiceValid: !result });
      if (result) this.props.updateValidity(false);
    });
  }

  doReview(invoice) {
    const model = { path: INVOICE_REVIEW.path.replace("{}", invoice.invoiceId) };
    toast(
      <span className="import-export-loader">
        <span className="loader">
          <FormattedMessage id={"common.generating"} />
        </span>
      </span>,
      { autoClose: false, closeButton: true }
    );
    if (invoice.invoiceType == TEMPLATE.value) {
      simpleFetch(
        "GET",
        GET_TEMPLATE_MISSING_FIELDS.path.replace("{}", invoice.invoiceId),
        {}
      ).then((res) => {
        const isError = res && res.hasOwnProperty("missingFields") && res["missingFields"].length > 0;
        if (isError) {
          toast.dismiss();
          const missingFields = res["missingFields"];
          const userLanguage = localStorage.getItem("languageCode") || EN.value;
          const extraDataItem = missingFields.find(item => item.extraData);
          const extraData = extraDataItem ? extraDataItem.extraData : [];
          const otherValuesSet = new Set(missingFields.filter(item => item !== extraDataItem));
          const otherValues = Array.from(otherValuesSet);
          const serverMessage = JSON.stringify(otherValues.map(item => typeof item === 'object' ? JSON.stringify(item) : item));
          const errorCodesToString = getParsedErrors(
            serverMessage,
            userLanguage,
            this.state.errorPath,
            extraData
          );
          this.setState({ errorsString: errorCodesToString, showModal: true });
        }
        else {
          invoice.invoiceStatusType = GENERATING.value;
          this.props.dataActions.simplePost({ model });
        }
      });
    }
    else {
      invoice.invoiceStatusType = GENERATING.value;
      this.props.dataActions.simplePost({ model });
    }

    const myInterval = setInterval(() => {
      simpleFetch(
        "GET",
        BILLING_PERIOD_LAST_VALID_INVOICE.path.replace("{}", invoice.billingPeriodId), {}
      ).then((response) => {
        if (response.invoiceStatusType == GENERATED.value && response.invoiceId != invoice.invoiceId) {
          toast.dismiss();
          const isEmpty = response.invoiceType == TEMPLATE.value && response.amount == 0;
          //Validates if amount is 0 while reviewing invoice
          if (isEmpty) {
            toast(
              <FormattedMessage id="invoices.datatable.actions.templateMissingClientInfo" />,
              {
                type: toast.TYPE.WARNING,
                autoClose: false,
              }
            );
          } else {
            if (!this.state.showModal && this.state.errorsString == null) {
              toast(
                <FormattedMessage id="invoices.datatable.actions.reviewGenerationSuccess" />,
                {
                  type: toast.TYPE.SUCCESS,
                  autoClose: 5000,
                }
              );
            }
          }
          this.props.refreshDataTable();
          clearInterval(myInterval);
        }
      }).catch(() => {
        toast.dismiss();
        clearInterval(myInterval);
        toast(
          <FormattedMessage id="validation.customMessages.serverErrors.genericError" />,
          {
            type: toast.TYPE.ERROR,
            autoClose: false,
          }
        );
      });
    }, 3000);
  }

  invoiceStatusCSS(statusValue) {
    let result = ` status-indicator status-${statusValue
      .toLowerCase()
      .replace(/_/g, "-")}`;

    return result;
  }

  getReviewButton() {
    const { invoice } = this.props;
    return (
      <button
        className="status-refresh"
        onClick={() => this.doReview(invoice)}
      >
        <span className="icon icon-loop" />
      </button>
    );
  }

  getRefreshButton() {
    const { refreshDataTable } = this.props;
    return (
      <button
        className="status-refresh"
        onClick={() => refreshDataTable()}
      >
        <span className="icon icon-loop" />
      </button>
    );
  }

  getStateDisplay(state, displayReview, displayRefresh, displayPACSS = true) {
    const { setCellClassNames, setPlanAdministratorCSS } = this.props;
    const additionalCSS = displayPACSS ? setPlanAdministratorCSS("state-format", null) : "";
    const classNames = setCellClassNames() + additionalCSS + this.invoiceStatusCSS(state.value);
    return (
      <span
        className={classNames}
      >
        <FormattedMessage id={state.key} />
        {displayReview && (
          this.getReviewButton()
        )}
        {displayRefresh && (
          this.getRefreshButton()
        )}
      </span>
    );
  }

  render() {
    const { invoice } = this.props;
    const { isInvoiceValid } = this.state;

    let state = GENERATING;
    let displayReview = false;
    let displayRefresh = true;
    let displayPACSS = false;
    const clientStatusType = this.props.client.clientStatusType;
    const isValidClientStatus = [IMPLEMENTATION.value, ACTIVE.value, INACTIVE.value].includes(clientStatusType);
    if (invoice.invoiceStatusType !== GENERATING.value) {
      displayPACSS = true;
      if (invoice.invoiceStatusType === FAILURE.value) {
        state = FAILURE;
        displayReview = invoice.invoiceStep === DRAFT.value && userHasAccess([ADMINISTRATOR, FINTECH]) && isValidClientStatus;
        displayRefresh = false;
      }
      else if (invoice.invoiceStep === DRAFT.value) {
        state = REVIEW;
        displayReview = !isInvoiceValid && isValidClientStatus;
        displayRefresh = false;
        if (invoice.invoiceType === TEMPLATE.value)
          state = TEMPLATE;
      }
      else {
        displayReview = false;
        displayRefresh = false;
        if (invoice.isPublished === true)
          state = PUBLISHED;
        else
          state = GENERATED;
      }
    }

    return (
      <div>
        {this.getStateDisplay(state, displayReview, displayRefresh, displayPACSS)}
        {renderErrorModal(
          this.state.showModal,
          this.closeModal,
          this.state.errorsString,
          "validation.clientFieldValidation.invoiceMEVError"
        )}
      </div>
    );
  }
}

InvoiceState.propTypes = {
  dataActions: PropTypes.object,
  invoice: PropTypes.object.isRequired,
  setCellClassNames: PropTypes.func.isRequired,
  setPlanAdministratorCSS: PropTypes.func.isRequired,
  updateValidity: PropTypes.func.isRequired,
  refreshDataTable: PropTypes.func.isRequired,
  client: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(InvoiceState);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/InvoiceState.js